import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useLogin from './useLogin';
import LoginDesktop from './desktop';
import LoginMobile from './mobile';

function Login() {
    const isMobile = useIsMobile(992);
    const viewModel = useLogin();

    return isMobile ? <LoginMobile viewModel={viewModel} /> : <LoginDesktop viewModel={viewModel} />;
}

export default Login;
